import { deriveYesNoString } from "./binaryValue"

export function compareBinaryMetricValues(
  value1: { float_value?: number | null; string_value?: string | null },
  value2: { float_value?: number | null; string_value?: string | null },
): boolean {
  return deriveYesNoString(value1) === deriveYesNoString(value2)
}

export function compareNumericalMetricValues(
  value1: { float_value?: number | null },
  value2: { float_value?: number | null },
): boolean {
  return value1.float_value === value2.float_value
}

export function compareCategoricalMetricValues(
  value1: { string_value?: string | null },
  value2: { string_value?: string | null },
): boolean {
  return (
    value1.string_value?.toLowerCase() === value2.string_value?.toLowerCase()
  )
}

export function compareSetMetricValues(
  value1: { set_value?: string[] | null },
  value2: { set_value?: string[] | null },
): boolean {
  const a = value1.set_value
  const b = value2.set_value
  if (a == null || b == null) {
    return a === b
  }
  const sortedA = [...a].sort()
  const sortedB = [...b].sort()
  return (
    sortedA.length === sortedB.length &&
    sortedA.every((v, i) => v === sortedB[i])
  )
}
